import React, { useCallback, useEffect, useState } from 'react';
import { Button, Snackbar, Typography } from '@material-ui/core';

import { useWindowFocus } from '../useWindowFocus';
import { useAppMeta } from './useAppMeta';
import VersionLabel from './VersionLabel';

const CheckVersion: React.FC = () => {
  const [open, setOpen] = useState(true);
  const { meta, didUpdate, currentVersion, loadMeta } = useAppMeta();
  const newVersion = meta?.version || '';
  const hasVersion = !!(newVersion && currentVersion);
  const isOpen = open && didUpdate && hasVersion;

  const resumeFocusEvent = useWindowFocus(
    useCallback(() => {
      setOpen(true);
      loadMeta();
    }, [loadMeta])
  );

  // load only if snackbar is closed
  useEffect(() => {
    resumeFocusEvent(!isOpen);
  }, [isOpen, resumeFocusEvent]);
  console.log('CheckVersion');
  return isOpen ? (
    <Snackbar
      open
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      message={<Typography>An update is available</Typography>}
      action={
        <Button
          size='small'
          color='primary'
          variant='contained'
          style={{ marginRight: 4 }}
          onClick={() => {
            setOpen(false);
            window.location.reload();
          }}
        >
          Update Now
        </Button>
      }
    />
  ) : null;
};

export default CheckVersion;
